import React from 'react'
import { NavLink } from 'react-router-dom'
import { BigStar } from './helpers/Star'
import { twitterverse } from './helpers/links'

const Welcome = () => {
  return (
    <div id="main" className="bodyContainer">
      <div className="wrapper">
        <div className="main">
          <div className="bigStar">
            <BigStar />
          </div>
          <h1>
            <center>Welcome To The Twitterverse</center>
          </h1>
          <p className="subheader">
            Join{' '}
            <a className="external-link" href="https://spacecadet.ventures" target="blank">
              Spacecadet
            </a>{' '}
            in celebrating 15 years of the little blue bird by exploring the best tweets of all-time, from the all-stars of the platform.
          </p>
          <div className="twitterverse_button-container">
            <NavLink to={twitterverse} className="button twitterverse_make-your-own">
              Enter
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Welcome
